import React from 'react';
import { FadeIn } from './FadeIn';
export function StatsBar() {
  const stats = [{
    number: '+250',
    label: 'profes confían'
  }, {
    number: '6+6',
    label: 'Tomos + Bonos'
  }, {
    number: '4.9/5',
    label: 'calificación ⭐'
  }, {
    number: '🇦🇷',
    label: 'Todo el país'
  }];
  return <div className="bg-navy-800 border-y border-gold/20 py-8 relative z-20" data-id="element-253">
      <div className="container mx-auto px-6" data-id="element-254">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 divide-x-0 md:divide-x divide-gold/10" data-id="element-255">
          {stats.map((stat, index) => <FadeIn key={index} delay={0.1 * index} direction="up" className="text-center px-4" data-id="element-256">
              <div className="font-numbers font-bold text-3xl md:text-4xl text-gold mb-1" data-id="element-257">
                {stat.number}
              </div>
              <div className="text-sm text-gray-300 uppercase tracking-wider font-medium" data-id="element-258">
                {stat.label}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </div>;
}